import { compareAddresses } from './compare-addresses';

import type { OfficeAddressFormValues } from '../../model/schemas';
import type { Address } from '../../model/types';

export function recoverHeadOfficeAddress(
  headOfficeAddress: Address | undefined,
  registeredAddress: Address | undefined
): OfficeAddressFormValues | undefined {
  if (!headOfficeAddress) return undefined;
  const sameAsRegisteredAddress =
    !!registeredAddress &&
    compareAddresses(headOfficeAddress, registeredAddress);

  return {
    sameAsRegisteredAddress,
    country: headOfficeAddress.country,
    region: headOfficeAddress.region,
    province: headOfficeAddress.province,
    cityOrMunicipality: headOfficeAddress.cityOrMunicipality,
    postalCode: headOfficeAddress.postalCode,
    barangay: headOfficeAddress.barangay,
    streetAndHouse: headOfficeAddress.streetAndHouse,
    unitAndFloor: headOfficeAddress.unitAndFloor,
  };
}
